import { render, staticRenderFns } from "./CreateBildungsgangFromTemplateModal.vue?vue&type=template&id=293aeb89"
import script from "./CreateBildungsgangFromTemplateModal.vue?vue&type=script&lang=js"
export * from "./CreateBildungsgangFromTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports